import { useQuery } from '@tanstack/react-query';
import { useProjectsContext } from 'src/modules/projects/context';

import { TierUsersResult, TierUsersTab } from '../domain/types';
import { mapTierUsersResponseToResult } from '../infra/mappers';
import { tierUsersService } from '../infra/tierUsersService';

export const tierUsersQueryKeys = {
  all: (projectId: string, tierId: string) => ['tier-users', projectId, tierId] as const,
  list: (projectId: string, tierId: string, tab: TierUsersTab, q: string, page: number, perPage: number) =>
    ['tier-users', projectId, tierId, { tab, q, page, perPage }] as const,
};

export interface UseTierUsersQueryArgs {
  tierId: string;
  tab: TierUsersTab;
  q: string;
  page: number;
  perPage: number;
  enabled?: boolean;
}

export function useTierUsersQuery({ tierId, tab, q, page, perPage, enabled = true }: UseTierUsersQueryArgs) {
  const { project } = useProjectsContext();
  const projectId = project?.id;

  return useQuery<TierUsersResult>({
    queryKey: tierUsersQueryKeys.list(projectId ?? '', tierId, tab, q, page, perPage),
    queryFn: async () => {
      const response = await tierUsersService.list(projectId as string, tierId, {
        tab,
        q: q || undefined,
        page,
        per_page: perPage,
      });
      return mapTierUsersResponseToResult(response);
    },
    enabled: enabled && !!projectId && !!tierId,
    placeholderData: (prev) => prev,
  });
}
